/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import loadable from '@loadable/component';

// regular addon
const LoadableAddOnsContentContainer = loadable(() => import(/* webpackChunkName: "GraphqlAddOnContentConainer" */ './GraphqlAddOnContentConainer'));

const AddOnsABContainer = ({ page }) => <LoadableAddOnsContentContainer page={page} />;

AddOnsABContainer.propTypes = {
    page: object.isRequired,
};

export default AddOnsABContainer;
